import React, { useEffect, useState } from "react";
import RegisterForm from "../../components/Forms/RegistrationForm";
import axios from "../../libs/axios";
import moment from "moment";

const Register = () => {
  const [dates, setDates] = useState(null);

  useEffect(() => {
    const getDates = async () => {
      try {
        const res = await axios.get("/registration-dates");

        if (res.status !== 200)
          throw new Error("Can not get registration dates.");

        setDates(res.data);
      } catch (err) {
        console.log(err);
      }
    };

    getDates();
  }, []);

  if (
    !dates ||
    moment(new Date()).isBefore(moment(dates?.start_date)) ||
    moment(new Date()).isAfter(moment(dates?.end_date))
  ) {
    return (
      <div className="w-full md:w-2/3 mx-auto p-6 h-[80dvh]">
        <div className="card w-full lg:w-1/2 bg-base-100 shadow-xl mx-auto mt-6">
          <div className="card-body text-center">
            {moment(new Date()).isBefore(moment(dates?.start_date))
              ? "რეგისტრაცია არ დაწყებულა"
              : moment(new Date()).isAfter(moment(dates?.end_date))
              ? "რეგისტრაცია დასრულდა"
              : "რეგისტრაციის თარიღი არაა ცნობილი"}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full lg:w-3/4 mx-auto p-6">
      <div className="card w-full lg:w-2/3 bg-base-100 shadow-xl mx-auto mt-6">
        <div className="card-body">
          <RegisterForm />
        </div>
      </div>
    </div>
  );
};

export default Register;
